var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg005Pufferfish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#ff6c52",
    r: 256
  }))))))), /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0-10.613-.646-21.075-1.901-31.349l-89.376-89.376-362.216 182.788 193.912 193.912c1.192.016 2.385.025 3.581.025 141.385 0 256-114.615 256-256z",
    fill: "#f92814"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m104.231 222.691-57.872-16.991 12.148 112.364 69.319-37.141z",
    fill: "#fdba12"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m407.769 222.691 57.872-16.991-12.148 112.364-69.319-37.141z",
    fill: "#ffa300"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m256 189.07c73.848 0 137.933 41.79 169.903 103.01 2.46-11.641 3.763-23.708 3.763-36.08 0-95.913-77.753-173.666-173.666-173.666s-173.666 77.753-173.666 173.666c0 12.373 1.304 24.44 3.763 36.08 31.97-61.22 96.055-103.01 169.903-103.01z",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.903 292.08c2.46-11.641 3.763-23.708 3.763-36.08 0-95.913-77.753-173.666-173.666-173.666v106.736c73.848 0 137.933 41.79 169.903 103.01z",
    fill: "#fdba12"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 188.07c-73.967 0-138.142 41.924-170.06 103.305 16.338 78.949 86.269 138.29 170.06 138.29s153.721-59.341 170.06-138.29c-31.918-61.381-96.093-103.305-170.06-103.305z",
    fill: "#ffe89c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 188.07v241.596c83.791 0 153.721-59.341 170.06-138.29-31.918-61.382-96.093-103.306-170.06-103.306z",
    fill: "#fad17f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 119.967,
    cy: 162.42,
    fill: "#fff",
    r: 39.508
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 111.325,
    cy: 162.42,
    fill: "#414952",
    r: 14.953
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 392.033,
    cy: 162.42,
    fill: "#e9edf5",
    r: 39.508
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 400.675,
    cy: 162.42,
    fill: "#23272b",
    r: 14.953
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 185.903,
    fill: "#7e8596",
    rx: 42.214,
    ry: 42.214,
    transform: "matrix(.16 -.987 .987 .16 31.491 408.819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 143.689v84.427c23.314 0 42.214-18.9 42.214-42.214s-18.9-42.213-42.214-42.213z",
    fill: "#636978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 243.116c-31.548 0-57.214-25.666-57.214-57.214s25.666-57.214 57.214-57.214 57.214 25.666 57.214 57.214-25.666 57.214-57.214 57.214zm0-84.427c-15.006 0-27.214 12.208-27.214 27.214s12.208 27.214 27.214 27.214 27.214-12.208 27.214-27.214-12.208-27.214-27.214-27.214z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 128.689v30c15.006 0 27.214 12.208 27.214 27.214s-12.208 27.213-27.214 27.213v30c31.548 0 57.214-25.666 57.214-57.214s-25.666-57.213-57.214-57.213z",
    fill: "#e9edf5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.826,
    cy: 306.711,
    fill: "#ffce00",
    rx: 19.754,
    ry: 19.754,
    transform: "matrix(.16 -.987 .987 .16 -195.4 383.757)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 166.654,
    cy: 359.009,
    fill: "#ffce00",
    rx: 14.903,
    ry: 14.903,
    transform: "matrix(.23 -.973 .973 .23 -221.041 438.722)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.461,
    cy: 312.078,
    fill: "#ffce00",
    rx: 16.114,
    ry: 16.114,
    transform: "matrix(.23 -.973 .973 .23 -152.406 431.582)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 334.178,
    fill: "#ffce00",
    r: 16.114
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 318.063v32.229c8.9 0 16.114-7.215 16.114-16.114s-7.214-16.115-16.114-16.115z",
    fill: "#fdba12"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 166.654,
    cy: 250,
    fill: "#ffce00",
    r: 15.484
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 229.614,
    cy: 378.989,
    fill: "#ffce00",
    r: 12.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 229.614,
    cy: 276.715,
    fill: "#ffce00",
    rx: 11.231,
    ry: 11.231,
    transform: "matrix(.924 -.383 .383 .924 -88.416 108.933)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 384.174,
    cy: 306.711,
    fill: "#fdba12",
    rx: 19.754,
    ry: 19.754,
    transform: "matrix(.987 -.16 .16 .987 -44.169 65.498)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 345.346,
    cy: 359.009,
    fill: "#fdba12",
    rx: 14.903,
    ry: 14.903,
    transform: "matrix(.973 -.23 .23 .973 -73.245 88.948)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 315.539,
    cy: 312.078,
    fill: "#fdba12",
    rx: 16.114,
    ry: 16.114,
    transform: "matrix(.973 -.23 .23 .973 -63.26 80.845)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 345.346,
    cy: 250,
    fill: "#fdba12",
    r: 15.484
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 282.386,
    cy: 378.989,
    fill: "#fdba12",
    r: 12.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.386,
    cy: 276.715,
    fill: "#fdba12",
    rx: 11.231,
    ry: 11.231,
    transform: "matrix(.383 -.924 .924 .383 -81.33 431.711)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg005Pufferfish);
export default __webpack_public_path__ + "static/media/005-pufferfish.05a5a1dbf40321f335be0728281baea1.svg";
export { ForwardRef as ReactComponent };